import { useEffect } from 'react'

import { trackExperimentViewed } from '@mc/track-event'

import { useExperimentCriteria } from './useExperimentCriteria'
import { EXPERIMENT_FLAG_KEY } from '../constants'

export const useTrackPen5108Experiment = () => {
  const { experimentCriteria } = useExperimentCriteria()

  useEffect(() => {
    if (experimentCriteria) {
      trackExperimentViewed(EXPERIMENT_FLAG_KEY)
    }
  }, [experimentCriteria])
}
